import { PaperReferralApprovalResult } from '@dreryk/egabinet-referral-frontend-api';
import { VisitReferralToAnalyticalExaminationApproveCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { PromiseVoidFunction } from '@dreryk/react-common';
import { ActionBar, ButtonVariant } from '@dreryk/react-components';
import { useDraftRemoveByTokenCqrsCommand } from '@dreryk/react-draft';

import { getReferralDraftToken } from '../../referral.draft';
import { useReferralPrintCommandSuccessHandler } from '../../shared/useReferralPrintCommandSuccessHandler';
import { referralTranslationKeys } from '../../translations';
import {
   ReferralToAnalyticalExaminationFormBean,
   ReferralToAnalyticalExaminationFormController,
} from '../ReferralToAnalyticalExaminationForm/ReferralToAnalyticalExaminationForm.types';

import { mapReferralToAnalyticalExaminationFormBeanToReferralCommandDetails } from './ReferralToAnalyticalExaminationSendAction.utils';

type ReferralToAnalyticalExaminationSendActionProps = {
   readonly handleSubmit: ReferralToAnalyticalExaminationFormController['handleSubmit'];
   readonly visitId: number;
   readonly onSuccess: PromiseVoidFunction | VoidFunction;
};

export const ReferralToAnalyticalExaminationSendAction = (
   props: ReferralToAnalyticalExaminationSendActionProps
): JSX.Element => {
   const handlePrintSuccess = useReferralPrintCommandSuccessHandler({
      visitId: props.visitId,
      onPrintDone: props.onSuccess,
   });

   const { executeAsync: removeDraft } = useDraftRemoveByTokenCqrsCommand();

   const { executeAsync: sendReferralToAnalyticalExamination } = useCqrsCommand<
      PaperReferralApprovalResult,
      ReferralToAnalyticalExaminationFormBean
   >(
      (parameters) => {
         const command = new VisitReferralToAnalyticalExaminationApproveCommand();
         command.referralDetails = mapReferralToAnalyticalExaminationFormBeanToReferralCommandDetails(parameters);
         command.visitId = props.visitId;
         return command;
      },
      {
         onSuccess: async (result) => {
            handlePrintSuccess(result);
            await removeDraft({ token: getReferralDraftToken('referralToAnalyticalExamination', props.visitId) });
         },
      }
   );
   return (
      <ActionBar.PrimaryButton
         variant={ButtonVariant.PRIMARY}
         onClick={props.handleSubmit(sendReferralToAnalyticalExamination)}
         label={referralTranslationKeys.actionBar.confirmAndPrint}
         testId={'confirmAndPrint'}
         blockingOperation
      />
   );
};
